var LayerParams;
(function (LayerParams) {
    LayerParams["standFill"] = "standFill";
    LayerParams["standBorder"] = "standBorder";
    LayerParams["sourceId"] = "stands";
})(LayerParams || (LayerParams = {}));
export default LayerParams;
